import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap"
import PropTypes from "prop-types"

const ModalPendingAccount = (props) => {
    
    const [pendingAccounts, setPendingAccounts] = useState([])

    useEffect(()=>{
        setPendingAccounts(props.accounts);
    },[props.accounts])

    return (
        <Modal size="lg" show={props.visible} onHide={()=>props.setVisible(false)}>
            <Modal.Header className="custom-modal-header" closeButton>
                <Modal.Title>Cuentas a crédito pendientes de pago</Modal.Title>
            </Modal.Header>
            <Modal.Body>                
                <div style={styles.header}>
                    <h4 style={styles.title}>
                        🏦 Selecciona la cuenta a pagar, <br />
                        <small style={{color: '#f00', fontSize: 12}}>Nota: Asegúrese de abrir una cuenta a la vez, realizar el pago correspondiente y luego procesar las demás...</small>
                    </h4>
                </div>
                    
                <div style={styles.body}>                    

                    <div style={styles.grid}>
                        {pendingAccounts.map(account => (
                            <div key={`account-id-${account.account_id}`} style={styles.card} onClick={()=>{
                                window.open(`${process.env.REACT_APP_PATH_APP}v10/payments?app=173&accountPay=${account.account_id}`,'_blank')
                                props.setVisible(false)
                            }}>

                                <div style={styles.cardHeader}>
                                    <h6 style={{margin: 0}}>#Cuenta: {account.account_id} - {account.customer_name}</h6>
                                    <span style={styles.badge}>
                                        ${account.total_pending_amount}
                                    </span>
                                </div>

                            </div>
                        ))}
                    </div>
                </div>
                    
                <div style={styles.footer}>
                    
                    <div style={{display: 'flex', gap: '0.5rem'}}>
                        <button 
                            style={{...styles.button, ...styles.buttonSecondary}}
                            onClick={()=>props.setVisible(false)}
                            >
                            Cancelar
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    },
    modal: {
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      maxWidth: '90vw',
      maxHeight: '90vh',
      width: '800px',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    },
    header: {
      padding: '1rem 1.5rem',
      borderBottom: '1px solid #dee2e6',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#f8f9fa'
    },
    title: {
      margin: 0,
      fontSize: '1.25rem',
      fontWeight: '500'
    },
    closeButton: {
      background: 'none',
      border: 'none',
      fontSize: '1.5rem',
      cursor: 'pointer',
      padding: '0.25rem',
      color: '#6c757d'
    },
    body: {
      padding: '1.5rem',
      overflow: 'auto',
      flex: 1
    },
    footer: {
      padding: '1rem 1.5rem',
      borderTop: '1px solid #dee2e6',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#f8f9fa'
    },
    alert: {
      padding: '0.75rem 1rem',
      marginBottom: '1rem',
      border: '1px solid #b6d7ff',
      borderRadius: '0.375rem',
      backgroundColor: '#cff4fc',
      color: '#055160'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '1rem'
    },
    card: {
      border: '1px solid #dee2e6',
      borderRadius: '0.375rem',
      overflow: 'hidden',
      backgroundColor: 'white',
      cursor: 'pointer'
    },
    cardHeader: {
      padding: '0.75rem 1rem',
      backgroundColor: '#f8f9fa',
      borderBottom: '1px solid #dee2e6',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    cardBody: {
      padding: '1rem'
    },
    cardFooter: {
      padding: '0.75rem 1rem',
      backgroundColor: '#f8f9fa',
      borderTop: '1px solid #dee2e6'
    },
    badge: {
      padding: '0.25rem 0.5rem',
      fontSize: '0.75rem',
      fontWeight: '500',
      borderRadius: '0.375rem',
      backgroundColor: '#6c757d',
      color: 'white'
    },
    button: {
      padding: '0.375rem 0.75rem',
      border: '1px solid transparent',
      borderRadius: '0.375rem',
      fontSize: '0.875rem',
      fontWeight: '400',
      textAlign: 'center',
      cursor: 'pointer',
      textDecoration: 'none',
      display: 'inline-block'
    },
    buttonPrimary: {
      backgroundColor: '#0d6efd',
      borderColor: '#0d6efd',
      color: 'white'
    },
    buttonSecondary: {
      backgroundColor: '#6c757d',
      borderColor: '#6c757d',
      color: 'white'
    },
    buttonSuccess: {
      backgroundColor: '#198754',
      borderColor: '#198754',
      color: 'white'
    },
    buttonOutline: {
      backgroundColor: 'transparent',
      borderColor: '#0d6efd',
      color: '#0d6efd'
    },
    listItem: {
      padding: '0.5rem 0',
      borderBottom: '1px solid #f8f9fa'
    },
    small: {
      fontSize: '0.875rem',
      color: '#000'
    },
    textMuted: {
      color: '#6c757d'
    }
};

ModalPendingAccount.propTypes = {
    accounts: PropTypes.array,
    visible: PropTypes.bool,
    setVisible: PropTypes.func
}

export default ModalPendingAccount